"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandName = void 0;
exports.brandName = {
    boticario: 'O Boticário',
    BOT: 'O Boticário',
    eudora: 'Eudora',
    EUD: 'Eudora',
    oui: 'OUI',
    OUI: 'OUI',
    EAM: 'Eu Amo Make',
    euamomake: 'Eu Amo Make',
};
